import BaseService from './base.service';

/**
 * Package Service
 * Business logic layer for package management
 */
class PackageService extends BaseService {
  constructor() {
    super('packages');
  }

  /**
   * Get all packages with pricing and features
   * @returns {Promise|null}
   */
  async getAllPackages() {
    try {
      return await this.dao.getAllPackages();
    } catch {
      return null;
    }
  }

  /**
   * Get package by ID
   * @param {number} id - Package ID
   * @returns {Promise|null}
   */
  async getPackageById(id) {
    try {
      return await this.dao.getPackageById(id);
    } catch {
      return null;
    }
  }

  /**
   * Get package by code (free, plus, pro)
   * @param {string} code - Package code
   * @returns {Promise|null}
   */
  async getPackageByCode(code) {
    try {
      return await this.dao.getPackageByCode(code);
    } catch {
      return null;
    }
  }

  /**
   * Check entitlement for a feature (requires authentication)
   * @param {string} featureCode - Feature code
   * @returns {Promise|null}
   */
  async checkEntitlement(featureCode) {
    try {
      return await this.dao.checkEntitlement(featureCode);
    } catch {
      return null;
    }
  }

  /**
   * Format package data for display
   * @param {Object} pkg - Raw package data
   * @returns {Object} - Formatted package data
   */
  formatPackageData(pkg) {
    if (!pkg) return null;

    return {
      ...pkg,
      displayName: pkg.name,
      isFree: pkg.code === 'free',
      isPremium: pkg.code === 'plus' || pkg.code === 'pro',
    };
  }
}

export default new PackageService();

